export function getLocal(key) {
  let localkey = key;
  if (!localkey && localkey.length <= 0) return;
  let val = window.localStorage.getItem(localkey);
  let localval = JSON.parse(val);
  return localval;
}
export function getSessionStorage(key) {
  let localkey = key;
  if (!localkey && localkey.length <= 0) return;
  let val = window.sessionStorage.getItem(localkey);
  let localval = JSON.parse(val);
  return localval;
}

export function getLocaSync(key) {
  return new Promise(resolve => {
    let localkey = key;
    if (!localkey && localkey.length <= 0) return;
    let val = window.localStorage.getItem(localkey);
    let localval = JSON.parse(val);
    resolve(localval);
  })
}


export function setLocal(object) {
  let localkey = object.key;
  if (!localkey && localkey.length <= 0) return;
  let localval = JSON.stringify(object.data);
  window.localStorage.setItem(localkey, localval);
}
export function setSessionStorage(object) {
  let localkey = object.key;
  if (!localkey && localkey.length <= 0) return;
  let localval = JSON.stringify(object.data);
  window.sessionStorage.setItem(localkey, localval);
}

export function setLocalSync(object) {
  return new Promise(resolve => {
    let localkey = object.key;
    if (!localkey && localkey.length <= 0) return;
    let localval = JSON.stringify(object.data);
    window.localStorage.setItem(localkey, localval);
    resolve('ok');
  })
}

export function delLocal(key) {
  let localkey = key;
  if (!localkey && localkey.length <= 0) return;
  let val = window.localStorage.removeItem(localkey);
  return val;
}

export function delSession(key) {
  let localkey = key;
  if (!localkey && localkey.length <= 0) return;
  let val = window.sessionStorage.removeItem(localkey);
  return val;
}



// WEBPACK FOOTER //
// ./src/assets/storage.js